import React, { useRef, useState } from 'react';
import { Box, Table, TableBody, TableCell, Typography, TableRow, IconButton, Popper, Paper } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const MACROS = [
  { macro: '{company_name} or ${company_name}', description: 'Your company name' },
  { macro: 'https://axlehi.re/${tracking_code}', description: 'Link to tracking code' },
  { macro: '${tracking_url}', description: 'Tracking Url' },
  { macro: '${reason}', description: 'Reason of stop failed or succeeded' },
  { macro: '{dropoff_latest_local_hour_minute}', description: 'Time dropoff' },
  { macro: '${customer_name}', description: 'Customer name' },
  { macro: '${customer_first_name}', description: 'Customer First Name' },
  { macro: '${actual_delivery_date}', description: 'Actual Delivery Date' },
  { macro: '${shipment_delivery_date}', description: 'Shipment Delivery Date' },
  { macro: 'axl_shipment_token=${tracking_token}', description: 'Open Recipient tracking page without authentication' },
  { macro: '${tracking_token_ttl_minute}', description: 'Expired time of tracking token' },
];

const Description = ({ sx, placement = 'bottom-start' }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen((prev) => !prev);

  return (
    <Box sx={[{ mt: '20px', px: '24px', py: '8px' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography>Noted*</Typography>
        <IconButton ref={anchorRef} onClick={toggleOpen} size="small" aria-label="Noted*" aria-expanded={open}>
          <InfoOutlinedIcon />
        </IconButton>
      </Box>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement={placement}
        sx={(theme) => ({ zIndex: theme.zIndex.modal })}
      >
        <Paper elevation={4} sx={{ px: 2, py: 1, maxHeight: '60vh', overflowY: 'auto' }}>
          <Table sx={{ '& td': { borderBottom: 'none', padding: '5px' } }}>
            <TableBody>
              {MACROS.map(({ macro, description }) => (
                <TableRow key={macro}>
                  <TableCell>{macro}</TableCell>
                  <TableCell>{description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Popper>
    </Box>
  );
};

export default Description;
